/* eslint-disable complexity */
import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import Icon from 'carbon-react/lib/components/icon';

import styles from './sync-control-cta.scss';

interface SyncControlCtaProps {
  onClick?: () => void;
  showLabel?: boolean;
  message?: React.ReactNode;
}

export const SyncControlCta = ({ onClick, showLabel, message }: SyncControlCtaProps) => {
  const intl = useIntl();

  const defaultMessage = intl.formatMessage({
    id: 'common.sync_now',
    defaultMessage: 'Sync now'
  });

  return (
    <div style={showLabel ? { paddingLeft: 4, paddingRight: 4 } : {}}>
      {showLabel ? (
        <div className={clsx('uiTypeFont14Regular', styles.label)} onClick={onClick}>
          {message || defaultMessage}
        </div>
      ) : (
        <div style={{ display: 'flex' }}>
          <button
            onClick={onClick}
            style={showLabel ? { padding: 4 } : {}}
            aria-label={!showLabel ? defaultMessage : undefined}
            className={styles.transparentBtn}
          >
            <Icon type="sync" className={clsx(styles.syncIcon)} />
          </button>
          <div style={{ marginLeft: 8 }}>
            <Icon type="tick" fontSize="small" color="#777" />
          </div>
        </div>
      )}
    </div>
  );
};
